import React from 'react';
import { Link } from 'gatsby';
import DocSearch from './DocSearch';
import logoImage from './logo.png';
import styles from './header.module.scss';
var githubLink = process.env.GATSBY_GITHUB_LINK;

function Header() {
  return React.createElement("div", {
    className: "header"
  }, React.createElement("div", {
    className: "logo-wrapper"
  }, React.createElement(Link, {
    to: "/"
  }, React.createElement("img", {
    src: logoImage,
    alt: "logo",
    className: "logo"
  }))), React.createElement(DocSearch, null), githubLink && React.createElement("a", {
    href: githubLink,
    target: "_blank",
    rel: "noopener noreferrer",
    className: styles.githubLink
  }, React.createElement("span", null, "GitHub")));
}

export default Header;